import { Component, Prop, h, Method, Host } from "@stencil/core";
import { TitleTypeEnum } from "./TitleTypeEnum";
import clampJs from "clamp-js-main";

@Component({
  tag: "snt-title",
  styleUrl: "./title-component.scss",
  shadow: false,
})
export class TitleComponent {
  public static readonly TAG_NAME = "snt-title";

  @Prop() titleType: string;
  @Prop() clampLines: number = 0;
  @Prop() truncationString: string = "...";
  private titleElement: HTMLElement; // This is the text itself

  getContent(titleType: string): any {
    switch (titleType) {
      case TitleTypeEnum.h1:
        return (
          <h1
            ref={(el) => {
              this.titleElement = el;
            }}
            class="header"
          >
            <slot />
          </h1>
        );
      case TitleTypeEnum.h2:
        return (
          <h2
            ref={(el) => {
              this.titleElement = el;
            }}
            class="header"
          >
            <slot />
          </h2>
        );
      case TitleTypeEnum.h3:
        return (
          <h3
            ref={(el) => {
              this.titleElement = el;
            }}
            class="header"
          >
            <slot />
          </h3>
        );
      case TitleTypeEnum.h4:
        return (
          <h4
            ref={(el) => {
              this.titleElement = el;
            }}
            class="header"
          >
            <slot />
          </h4>
        );
      default:
        return "";
    }
  }

  componentDidRender() {
    if (this.clampLines > 0) {
      (clampJs as any).clamp(this.titleElement, {
        clamp: this.clampLines,
        truncationChar: this.truncationString,
        useNativeClamp: false,
      });
    }
  }

  @Method()
  async clampTitle(clampLines: number = this.clampLines) {
    (clampJs as any).clamp(this.titleElement, {
      clamp: clampLines,
      truncationChar: this.truncationString,
      useNativeClamp: false,
    });
  }

  @Method()
  async setTitle(title: string) {
    this.titleElement.innerHTML = title;
  }

  render() {
    // This is to solve the rendering issue where Bing/Google does not "see" the <h*> tag.
    // Must wrap the <h* class="header"> element inside where component is used and this will use it as <slot> directly
    // Existing usage with prop titleType will still work.
    let content = this.titleType ? this.getContent(this.titleType) : <slot />;

    return (
      <Host>
        <div class="spacings">
          {content}
        </div>
      </Host>
    );
  }
}
